import titleAndDescription from './TitleAndDescription';
import mainCharts from './MainCharts';
import issueCharts from './IssueCharts';
import progressCharts from './ProgressCharts';

export default [titleAndDescription, mainCharts, issueCharts, progressCharts];
